<script setup lang="ts">
import { tsKey } from '@/general/services/translations/translation.key';
import EmptyState from '@/general/ui/components/empty-state.vue';
import { inject } from 'vue';
import { brandServiceKey } from '../ts/keys/brand.keys';

const ts = inject(tsKey)!;
const service = inject(brandServiceKey);
</script>

<template>
  <EmptyState
    :translation-service="ts"
    :icon-name="'brands'"
    :button-icon="'mdi mdi-plus'"
    :empty-state-subtitle="ts.tModule('emptySearchStateSubTitle')"
    @clicked="service?.openCrudComponent()"
  />
</template>
